import cloudWordModule from "@/views/cloudWord/index.vue";

export const cloudWordRoutes = [
  // 云服务工作台
  {
    path: "/cloudWord",
    component: cloudWordModule,
    redirect: "/cloudWord/cloud-word",
    meta: {
      title: "cloudWord",
    },
    children: [
      {
        path: "/cloudWord/cloud-word",
        name: "cloud-word",
        component: () => import("@/views/cloudWord/cloud-word.vue"),
        meta: {
          title: "云工作台首页",
        },
      },
      {
        path: "/cloudWord/cloud-server/:id",
        name: "cloud-server",
        component: () =>
          import("@/views/cloudWord/cloud-server/cloud-server.vue"),
        meta: {
          title: "实例详情",
        },
      },
    ],
  },
];
